<form [formGroup]="form1" (ngSubmit)="update()">
    <div class="card">
        <div class="card-header text-center" style="text-transform: uppercase">
            MODIFICAR GUARDIA
        </div>
        <div class="card-body">
            <div class="row gx-3 mb-3">
                <div class="col-md-6 col-sm-12">
                    <label class="small mb-1" for="name">Nombre</label>
                    <div class="input-group">
                        <input type="text" class="form-control text-capitalize" formControlName="name" uppercaseInput />
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <label class="small mb-1" for="lastname">Apellidos</label>
                    <div class="input-group">
                        <input type="text" class="form-control text-capitalize" formControlName="lastname"
                            uppercaseInput />
                    </div>
                </div>
                <div class="col-md-8 col-sm-12">
                    <label class="small mb-1" for="rut">RUT/IDENTIFICACIÓN</label>
                    <div class="input-group">
                        <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-id-card"></i></span>
                        <input type="text" class="form-control" formControlName="rut" uppercaseInput
                            (keyup)="onFormatRut($event)" />
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <label class="small mb-1" for="rut">CURSO OS10</label>
                    <div class="input-group">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="fa-solid fa-file-shield"></i>
                        </span>
                    <select class="form-select" formControlName="os10">
                        <option value="si">SI</option>
                        <option value="no">NO</option>
                    </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="rut">ESTADO</label>
                    <div class="input-group">
                      <select class="form-select" formControlName="state_id">
                        <option *ngFor="let item of states" [value]="item.id">{{item.tag}}</option>
                      </select>
                    </div>
                  </div>
                <div class="col-md-6 col-sm-12">
                    <label class="small mb-1" for="position_id">CARGO</label>
                    <div class="input-group">
                        <span class="input-group-text"><i class="fa-solid fa-tag"></i></span>
                        <select class="form-select" formControlName="position_id">
                            <option value="">Sin cargo</option>
                            <option *ngFor="let p of positions" [value]="p.id">{{ p.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <label class="small mb-1" for="email">Email</label>
                    <div class="input-group flex-nowrap">
                      <span class="input-group-text" id="addon-wrapping"><i class="fa-regular fa-envelope"></i></span>
                      <input type="email" class="form-control" placeholder="Email  contacto" formControlName="email" />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <label class="small mb-1" for="phone">Tel.</label>
                    <div class="input-group flex-nowrap">
                      <span class="input-group-text" id="addon-wrapping"><i class="fa-solid fa-phone"></i></span>
                      <input type="email" class="form-control" placeholder="Telefono contacto" formControlName="phone" />
                    </div>
                  </div>
            </div>
            <button class="btn btn-primary w-100" type="submit">GUARDAR CAMBIOS</button>
        </div>
    </div>
</form>
